'use client';
import Image from 'next/image';

export default function BrandLogos() {
  const logos = [
    '/logos/pilatis.png',
    '/logos/general2.png',
    '/logos/general.png',
    '/logos/cardio.png',
    '/logos/emsSuit.png',
    '/logos/emsculpt.png',
    '/logos/pilatis1.png',
  ];

  // Duplicate the array so the marquee loops seamlessly
  const scrollingLogos = [...logos, ...logos];

  return (
    <section className="relative py-3 bg-black border-t border-b border-[#faaf40]/40 overflow-hidden">
      {/* Gold gradient overlay */}
      <div
        className="absolute inset-0 opacity-60"
        style={{
          background: 'linear-gradient(90deg, #faaf40 0%, #fcd77a 100%)',
        }}
      ></div>

      {/* Marquee Container */}
      <div className="relative flex whitespace-nowrap animate-marquee">
        {scrollingLogos.map((src, index) => (
          <div
            key={index}
            className="flex justify-center items-center mx-10 transition-transform duration-300 hover:scale-110"
          >
            <Image
              src={src}
              alt="brand logo"
              width={100}
              height={100}
              className="opacity-95 hover:opacity-100 transition-opacity duration-300 filter drop-shadow-[0_0_8px_rgba(255,255,255,0.9)]"
            />
          </div>
        ))}
      </div>
    </section>
  );
}
